import type {
  MatchBand,
  MatchCriteriaStatus,
  MatchCriteriaType,
} from '@/api/types/matchCriteria'
import { ReactComponent as Appointments } from '@/assets/svgs/appointments.svg'
import { ReactComponent as Certificate } from '@/assets/svgs/certificate.svg'
import { ReactComponent as CircledCheckmark } from '@/assets/svgs/circled-checkmark.svg'
import { ReactComponent as CircledCross } from '@/assets/svgs/circled-cross.svg'
import { ReactComponent as CircledDash } from '@/assets/svgs/circled-dash.svg'
import { ReactComponent as Clock } from '@/assets/svgs/clock.svg'
import { ReactComponent as Heart } from '@/assets/svgs/heart.svg'
import { ReactComponent as Home } from '@/assets/svgs/home.svg'
import { ReactComponent as Tag } from '@/assets/svgs/icon-menu-item-tag.svg'
import { ReactComponent as Parking } from '@/assets/svgs/parking.svg'
import { ReactComponent as Paw } from '@/assets/svgs/paw.svg'
import { ReactComponent as Units } from '@/assets/svgs/units.svg'
import type { IconGeneratorComponentProp } from '@/UIkit/IconGenerator'

export const MATCH_CRITERIA_BAND: Record<MatchBand, string> = {
  top: 'Top Match',
  medium: 'Moderate Match',
  low: 'Weak Match',
}

export const MATCH_CRITERIA_ICON: Record<
  MatchCriteriaType,
  IconGeneratorComponentProp
> = {
  price_in_budget: Tag as IconGeneratorComponentProp,
  unit_match: Units as IconGeneratorComponentProp,
  commute_time: Clock as IconGeneratorComponentProp,
  housekeeping: Heart as IconGeneratorComponentProp,
  pet_friendly: Paw as IconGeneratorComponentProp,
  parking: Parking as IconGeneratorComponentProp,
  free_cancellation: Certificate as IconGeneratorComponentProp,
  in_house_cancellation: Home as IconGeneratorComponentProp,
  month_to_month_lease: Appointments as IconGeneratorComponentProp,
}

export const MATCH_CRITERIA_STATUS: Record<
  MatchCriteriaStatus,
  IconGeneratorComponentProp
> = {
  match: CircledCheckmark as IconGeneratorComponentProp,
  mismatch: CircledCross as IconGeneratorComponentProp,
  incomparable: CircledDash as IconGeneratorComponentProp,
}
